<template>
  <panel-layout
    id="orders-panel"
    :loading="!!(orders && orders.loading) || false"
    :heading="$t('general.sales')"
    :show-footer="false"
  >
    <div class="h-full min-h-0 flex flex-col overflow-hidden text-sm text-gray-800">
      <o-table
        v-model:data="orders"
        :headers="[
          '#',
          $t('general.customer'),
          $t('general.date'),
          $t('general.status'),
          $t('general.total'),
          $t('general.balance'),
          $t('general.actions')
        ]"
        scroll
        class="flex-shrink flex-grow min-h-0"
      >
        <template #row="props">
          <td :class="props.tdClass">
            <o-panel-link :path="'/order/' + props.row.idOrder" class="text-inherit hover:text-primary">
              {{ props.row.orderNumber }}
            </o-panel-link>
          </td>

          <td :class="props.tdClass">
            <o-panel-link :path="'/order/' + props.row.idOrder" class="text-inherit hover:text-primary">
              {{ props.row.customer.displayName || '-' }}
            </o-panel-link>
          </td>

          <td :class="props.tdClass">
            {{ props.row.dateLabel }}
          </td>

          <td :class="props.tdClass">
            <div class="flex flex-wrap items-center space-x-1">
              <o-chip flat :variant="props.row.closed ? 'success' : 'warning'">
                {{ props.row.closed ? $t('general.closed') : $t('general.open') }}
              </o-chip>
            </div>
          </td>

          <td :class="props.tdClass">
            {{ props.row.priceLabel }}
          </td>

          <td :class="props.tdClass">
            <template v-if="props.row.isPaid">
              <o-chip variant="success" flat>
                {{ $t('general.paid') }}
              </o-chip>
            </template>
            <template v-else>
              <span class="font-medium" :class="!props.row.isPaid && Number(props.row.paid) ? 'text-yellow-500' : 'text-red-600'">{{ props.row.remainingBalanceLabel }}</span>
            </template>
          </td>

          <td :class="props.tdClass">
            <o-tooltip :text="props.row.closed ? $t('order.view') : $t('order.edit')">
              <o-panel-link tag="o-button" :path="'/order/' + props.row.idOrder" :icon="props.row.closed ? 'view' : 'edit'" size="sm" flat />
            </o-tooltip>
          </td>
        </template>
      </o-table>
    </div>
  </panel-layout>
</template>
<script setup lang="ts">
// @ts-ignore
import PanelLayout from '@/components/panel/PanelLayout.vue'

// @ts-ignore
import {
  OTable,
} from '@/components/elements'

import {
  TablePager,
} from '@/_api/lib/pager'

import { usePanel } from '~/composables/usePanel'

const panel = usePanel()

const props = defineProps<{ ids?: string }>()

const { $api, $notification } = useNuxtApp()

const ids = props.ids?.split(',')

const orders = ref<any>(new TablePager(page => $api.order.ids(ids, page), 20))

const fetchOrders = async () => {
  try {
    await orders.value.load()
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

onMounted(() => {
  fetchOrders()
})
</script>
